export class LuggagePerFoldingSeat {
    id: number;
    regionId: number;
    values: LuggagePerFoldingSeatValue[];
}
export class LuggagePerFoldingSeatValue {
    transportModeId: number;
    value: number;
}